import { useEffect, useRef } from 'react';
import { useMutation } from 'convex/react';
import { api } from '../../../convex/_generated/api';

export default function useEnsureLaunchChallenges({ enabled, empty }) {
  const ensureLaunchChallenges = useMutation(api.challenges.ensureLaunchChallenges);
  const attemptedRef = useRef(false);

  useEffect(() => {
    if (!enabled || !empty || attemptedRef.current) return;

    attemptedRef.current = true;
    ensureLaunchChallenges({}).catch(() => {
      attemptedRef.current = false;
    });
  }, [empty, enabled, ensureLaunchChallenges]);
}
